import { refreshAuthTokens } from '@/entities/user'

import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'
import { isJwtFresh } from '@/shared/lib/utils/jwt/is-jwt-fresh'

export const getPhoneForChatMessage = async (
	token: string,
	setSessionToken: (token: string) => void
): Promise<string | undefined> => {
	if (!token) return undefined

	let accessToken = token

	if (!isJwtFresh(accessToken)) {
		try {
			const { data } = await refreshAuthTokens()
			const nextToken = data?.ACCESS_TOKEN

			if (!nextToken) return undefined

			setSessionToken(nextToken)
			accessToken = nextToken
		} catch {
			return undefined
		}
	}

	const phone = getPhoneFromJwtToken(accessToken)

	return phone ? String(phone) : undefined
}
